import {
  SegmentsGetThumbnailsListDto,
  SegmentsThumbnailItemDto,
  segmentsGetThumbnailsQueryKey,
  useSegmentsGetThumbnails,
} from '@mi-front/api-v2';

export type ThumbnailInfo = SegmentsThumbnailItemDto;

type UseApiThumbnailsRangeOptions = NonNullable<
  Parameters<typeof useSegmentsGetThumbnails<ThumbnailInfo[]>>[2]
>['query'];

function selectThumbnailsRange(response: SegmentsGetThumbnailsListDto): ThumbnailInfo[] {
  return response.data;
}

/**
 * React Query wrapper around api-v2 thumbnails range endpoint.
 */
export function useApiThumbnailsRange(
  stationId: string,
  from: string | number,
  to: string | number,
  options?: UseApiThumbnailsRangeOptions,
) {
  const isoFrom = new Date(from).toISOString();
  const isoTo = new Date(to).toISOString();

  // If the range is in the future, do not cache data more than 30 seconds.
  // Otherwise cache for 1 hour.
  const staleTime = new Date(to) >= new Date() ? 30 * 1000 : 60 * 60 * 1000;

  return useSegmentsGetThumbnails<ThumbnailInfo[]>(
    stationId,
    { from: isoFrom, to: isoTo },
    {
      query: {
        staleTime,
        select: selectThumbnailsRange,
        ...options,
      },
    },
  );
}

useApiThumbnailsRange.queryKey = (stationId: string, from: string | number, to: string | number) =>
  segmentsGetThumbnailsQueryKey(stationId, {
    from: new Date(from).toISOString(),
    to: new Date(to).toISOString(),
  });
